module.exports = __webpack_public_path__ + "img/19.0c38ecec.png";